import React from 'react'
import NextButton from '../../components/nextbutton/NextButton'
import "./skillspage.css"
import Navbar from "../../components/nav/Navbar"
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import SlideButton from '../../components/slidebtn/SlideButton'
import { slidedata } from '../../utils/slidedata'
import Skillcard from '../../components/skillcard/Skillcard'
import { skillcarddata } from "../../utils/skillcarddata"
import NextButtonMobile from '../../components/nextButtonMobile/NextButtonMobile'
import Navbarmobile from '../../components/navbarmobile/Navbarmobile'
import MobileSlide from '../../components/mobileSlide/MobileSlide'
import PhoneSlide from '../../components/PhoneSlide/PhoneSlide'
const Skillspage = () => {
    const [selected, setSelected] = React.useState(1)
    const mainWrapper = React.useRef()
  return (
    <div className="skillspage"
    >
        <div className="skillspage-wrapper">
            <Navbarmobile/>
            <Navbar/>
            <header className="skillspage-header">
                <motion.h1
                    initial={{y: -200}}
                    animate={{y: 0}}
                    transition={{type: "spring", delay: 1.6}}
                >What I do</motion.h1>
                <motion.div className="header-info"
                    initial={{x: "100vw"}}
                    animate={{x: 0}}
                    transition={{type: "spring", delay: 2.2, duration: 0.8}}
                >
                    <p>Hey there! welcome to some of the tech tools I use in my day to day career</p>
                    <p>Making sure to keep up to date with the modern skills.</p>
                </motion.div>
                <Link to="/projects">
                    <NextButtonMobile/>
                </Link>
                <Link to="/projects">
                    <NextButton/>
                </Link>
            </header>
            <motion.main className="skillspage-body"
                initial={{x: "100vw"}}
                animate={{x: 0}}
                transition={{type: "spring", delay: 4, duration: 0.8}}
            >
                <aside className="skillspage-body-header">
                    <h1>Skills</h1>
                </aside>
                <section className="skillspage-body-main">
                    <div className="skillspage-body-main-wrapper" ref={mainWrapper}>
                        {skillcarddata.map((carddata)=>
                            <Skillcard carddata={carddata} key={carddata.key}/>
                        )}
                    </div>
                </section>
                <aside className="skillspage-body-slidebtns">
                    {slidedata.map((slide)=> 
                        <SlideButton 
                        setSelected={setSelected}
                        slideActive={selected === slide.index}
                        key={slide.index}
                        slide={slide}
                        mainWrapper={mainWrapper}
                        selected={selected}
                        />
                    )}
                    {slidedata.map((slide)=> 
                        <MobileSlide 
                        setSelected={setSelected}
                        slideActive={selected === slide.index}
                        key={slide.index}
                        slide={slide}
                        mainWrapper={mainWrapper}
                        selected={selected}
                        />
                    )}
                    {slidedata.map((slide)=> 
                        <PhoneSlide 
                        setSelected={setSelected}
                        slideActive={selected === slide.index}
                        key={slide.index}
                        slide={slide}
                        mainWrapper={mainWrapper}
                        selected={selected}
                        />
                    )}
                </aside>
            </motion.main>
        </div>
    </div>
  )
}

export default Skillspage